import { useContext } from 'react';

import { LicensesContext } from './licenses-context';

export const useLicenses = <TActiveLicenses>(): TActiveLicenses => {
  const state = useContext(LicensesContext);

  if (!state) {
    throw new Error('useLicenses must be used within a LicenseConsumer');
  }

  return (state.activeOnline ?? state.defaults) as TActiveLicenses;
};
